import _ from 'lodash';
import { saveUserCartProducts } from '../actions/CartActions';

const initialState = { products: [] };

export function CartReducers(state = initialState, action) {
  if (action?.type === 'ADD_CART_ITEM') {
    const product = action?.payload?.product;
    const token = action?.payload?.token;
    const dispatch = action?.payload?.dispatch;
    let prevProducts = state?.products ?? [];

    const checkProduct = prevProducts?.find(p => p._id === product?._id);

    let addingProducts = [...prevProducts];

    if (checkProduct) {
      prevProducts = prevProducts?.filter(p => p?._id != product?._id);
      addingProducts = [...prevProducts, product];
    } else {
      addingProducts = [...prevProducts, product];
    }

    addingProducts = _.uniqBy(addingProducts, '_id');

    if (dispatch && token) {
      dispatch(saveUserCartProducts(token, addingProducts));
    }

    return {
      ...state,
      products: addingProducts,
    };
  } else if (action?.type === 'REMOVE_CART_PRODUCT') {
    const product = action?.payload?.product;
    const token = action?.payload?.token;
    const dispatch = action?.payload?.dispatch;

    let prevProducts = state?.products ?? [];

    const updatingProducts = prevProducts?.filter(p => p?._id != product?._id);

    if (dispatch && token) {
      dispatch(saveUserCartProducts(token, updatingProducts));
    }
    return {
      ...state,
      products: updatingProducts,
    };
  } else if (action?.type === 'USER_CART_PRODUCTS') {
    return {
      ...state,
      products: [...action.payload],
    };
  } else if (action?.type === 'CLEAR_CART') {
    return {
      ...state,
      products: [...action.payload],
    };
  } else if (action?.type === 'CLEAR_COURSES') {
    let products = state?.products ?? [];

    products = products?.filter(p => p.category !== 'Courses');
    return {
      ...state,
      products,
    };
  } else {
    return state;
  }
}
